import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import style from "./HomeMasterTable.module.scss";
import { Box, Text } from "@chakra-ui/react";

const DashboardTable: React.FC = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isFromDatePickerOpen, setIsFromDatePickerOpen] = useState(false);
  const [isToDatePickerOpen, setIsToDatePickerOpen] = useState(false);
  // const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    summary: {
      usersJoinedThisDate: 0,
      allBookingsMadeThisDate: 0,
      allDinersBookedThisDate: 0,
      pendingBookingsThisDate: 0,
      totalCancelledBookingsThisDate: 0,
      totalDinersCancelledThisDate: 0,
      totalEarningsThisDate: 0,
      creditUsedThisDate: 0,
      onboardRestaurantsThisDate: 0,
    },
    allData: {
      usersJoinedAllDate: 0,
      allBookingsMadeAllDate: 0,
      allDinersBookedAllDate: 0,
      pendingBookingsAllDate: 0,
      totalCancelledBookingsAllDate: 0,
      totalDinersCancelledAllDate: 0,
      totalEarningsAllDate: 0,
      creditUsedAllDate: 0,
      onboardRestaurantsAllDate: 0,
      totalCreditsAllDate: 0,
      totalCreditsBalanceAllDate: 0,

      marketingBannersAllDate: 0,
      totalFAQsAllDate: 0,
      notificationTemplatesAllDate: 0,
      giftCardsIssuedAllDate: 0,
      feedbackReceivedAllDate: 0,
      bugReportsReceivedAllDate: 0,
      inquiriesReceivedAllDate: 0,
    },
    dateRange: {
      startDate: "",
      endDate: "",
      formattedRange: "",
    },
  });

  // const formatDate = (date: Date) => {
  //   return date
  //     .toLocaleDateString("en-GB", {
  //       day: "2-digit",
  //       month: "2-digit",
  //       year: "numeric",
  //     })
  //     .replace(/\//g, "-");
  // };
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const fetchDashboardData = async () => {
    try {
      const formattedDate = formatDate(startDate);

      const response = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }/admin/dashboard?startDate=${formattedDate}&endDate=${formattedDate}&allStartDate=${formatDate(
          fromDate
        )}&allEndDate=${formatDate(toDate)}`
      );
      console.log(response.data);

      if (response.data.success) {
        setDashboardData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [startDate, fromDate, toDate]);

  const flex4Data = [
    {
      heading: "TOTAL USERS",
      value: dashboardData.summary.usersJoinedThisDate,
    },
    {
      heading: "TOTAL CONFIRMED BOOKING",
      value: dashboardData.summary.allBookingsMadeThisDate,
    },
    {
      heading: "TOTAL CONFIRMED DINERS",
      value: dashboardData.summary.allDinersBookedThisDate,
    },
    {
      heading: "TOTAL CANCELLED BOOKINGS",
      value: dashboardData.summary.totalCancelledBookingsThisDate,
    },
    {
      heading: "TOTAL CANCELLED DINERS",
      value: dashboardData.summary.totalDinersCancelledThisDate,
    },
    {
      heading: "TOTAL PENDING BOOKINGS",
      value: dashboardData.summary.pendingBookingsThisDate,
    },
    {
      heading: "TOTAL EARNINGS",
      value: dashboardData.summary.totalEarningsThisDate.toFixed(2),
    },
    {
      heading: "CREDITS AMOUNT USED",
      value: dashboardData.summary.creditUsedThisDate.toFixed(2),
    },
    {
      heading: "ONBOARD RESTAURANTS",
      value: dashboardData.summary.onboardRestaurantsThisDate,
    },
  ];

  const formatAllDataKey = (key: string) => {
    return key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .replace("All Date", "");
  };
  const dataLinks: Record<string, string> = {
    registeredRestaurant: "/Restaurantmanagement",
    registeredCommunity: "/Communitymanagement",
    organisedEvents: "/Eventmanagement",
    totalTablesBooked: "/Bookingmanagement",
    totalTableCancelled: "",
    totalMarketingBanner: "/Marketing",
    totalFAQ: "/faq",
    totalNotificationTemplate: "/Notifications",
    totalGiftCardIssued: "/Giftcards",
    totalFeedbackReceived: "/Helpcenter",
    totalBugReportsReceived: "/Helpcenter",
    totalInquiriesReceived: "/Helpcenter",
  };
  return (
    <>
      <div
        style={{
          width: "100%",
          maxWidth: "100%",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh",
          overflowY: "auto",
          position: "relative",
          paddingBottom: "50px",
          backgroundColor: "rgb(240 241 241)",
          padding: "30px 40px",
        }}
      >
        <div className={style.divFlex}>
          <div>
            <h2 className={style.title}>Hey, admin</h2>
            <p className={style.des}>
              here's what's happening with your business
            </p>
          </div>
          <div>
            {/* <DatePicker
              selected={startDate}
              className={style.datePicker}
              onChange={(date: Date) => {
                setStartDate(date);
              }}
              maxDate={new Date()}
            /> */}
            <Box position="relative">
              <Box
                borderRadius="12px"
                backgroundColor="#fff"
                padding="8px 12px"
                display="flex"
                gap="10px"
                alignItems="center"
                cursor="pointer"
                onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
              >
                <Text color="#424242" fontSize="14px">
                  {formatDate(startDate)}
                </Text>
                <img
                  src="/icons/calenderlogo.svg"
                  alt="dropdownarrow"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              {isDatePickerOpen && (
                <Box className={style.datepickerDiv}>
                  <DatePicker
                    selected={new Date(startDate)}
                    onChange={(date: Date) => {
                      setStartDate(date);
                      setIsDatePickerOpen(false);
                    }}
                    maxDate={new Date()}
                    inline
                  />
                </Box>
              )}
            </Box>
          </div>
        </div>

        {/* Flex4 Section */}
        <div className={style.flex4}>
          {flex4Data.map((item, index) => (
            <div className={style.box1} key={index}>
              <p>{item.heading}</p>
              <h2>{item.value}</h2>
            </div>
          ))}
        </div>

        {/* AllData Section */}
        <div>
          <div className={style.alldata}>
            <h2>All Data</h2>
            <Box style={{ display: "flex", gap: "10px" }}>
              <Box position="relative">
                {" "}
                <Box
                  borderRadius="12px"
                  backgroundColor="#fff"
                  padding="8px 12px"
                  display="flex"
                  gap="10px"
                  alignItems="center"
                  cursor="pointer"
                  onClick={() => setIsFromDatePickerOpen(!isFromDatePickerOpen)}
                >
                  <Text color="#424242" fontSize="14px">
                    {formatDate(fromDate)}
                  </Text>
                  <img
                    src="/icons/calenderlogo.svg"
                    alt="dropdownarrow"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>{" "}
                {isFromDatePickerOpen && (
                  <Box className={style.datepickerDiv}>
                    <DatePicker
                      selected={new Date(fromDate)}
                      onChange={(date: Date) => {
                        setFromDate(date);
                        setIsFromDatePickerOpen(false);
                      }}
                      maxDate={new Date()}
                      inline
                    />
                  </Box>
                )}{" "}
              </Box>

              <span style={{ alignSelf: "center", color: "#424242" }}> - </span>
              <Box position="relative">
                {" "}
                <Box
                  borderRadius="12px"
                  backgroundColor="#fff"
                  padding="8px 12px"
                  display="flex"
                  gap="10px"
                  alignItems="center"
                  cursor="pointer"
                  onClick={() => setIsToDatePickerOpen(!isToDatePickerOpen)}
                >
                  <Text color="#424242" fontSize="14px">
                    {formatDate(toDate)}
                  </Text>
                  <img
                    src="/icons/calenderlogo.svg"
                    alt="dropdownarrow"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>{" "}
                {isToDatePickerOpen && (
                  <Box className={style.datepickerDiv}>
                    <DatePicker
                      selected={new Date(toDate)}
                      onChange={(date: Date) => {
                        setToDate(date);
                        setIsToDatePickerOpen(false);
                      }}
                      maxDate={new Date()}
                      inline
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </div>

          <div className={style.allDataFlex}>
            {Object.entries(dashboardData.allData).map(
              ([key, value], index) => (
                <div className={style.box11} key={index}>
                  <div className={style.content}>
                    <div className={style.description}>
                      <p>{formatAllDataKey(key)}</p>
                      <h2>{value}</h2>
                    </div>
                    {/* <div className={style.arrowDiv}>
                      <a href={dataLinks[key]} rel="noopener noreferrer">
                        <img
                          src="/icons/arrowdown.svg"
                          alt="arrow down"
                          className={style.arrowdown}
                        />
                      </a>
                    </div> */}
                    {dataLinks[key] && (
                      <div className={style.arrowDiv}>
                        <a href={dataLinks[key]} rel="noopener noreferrer">
                          <img
                            src="/icons/arrowdown.svg"
                            alt="arrow down"
                            className={style.arrowdown}
                          />
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardTable;
